module.exports = __webpack_public_path__ + "img/ic_qrcode_wechat.98f1e5e.jpg";